/**
 * @generated SignedSource<<5426daba5aaa17b73696c293611cd7f6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TextBlock_contentBlock$data = {
  readonly text: string;
  readonly title: string | null | undefined;
  readonly " $fragmentType": "TextBlock_contentBlock";
};
export type TextBlock_contentBlock$key = {
  readonly " $data"?: TextBlock_contentBlock$data;
  readonly " $fragmentSpreads": FragmentRefs<"TextBlock_contentBlock">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TextBlock_contentBlock",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "text",
      "storageKey": null
    }
  ],
  "type": "TextBlock",
  "abstractKey": null
};

(node as any).hash = "2fdd0b2a8966ff58acdbd75e81382b8a";

export default node;
